import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Area } from '../../constants/area';
import { SaveContactPhoneInfo } from './contact-nav/contact-info-category-lists/models/save-contact-phone-info';
import { SaveContactEmailInfo } from './contact-nav/contact-info-category-lists/models/save-contact-email-info';
import { SaveContactAddressInfo } from './contact-nav/contact-info-category-lists/models/save-contact-address-info';
import { SaveContactRoleInfo } from './contact-nav/contact-info-category-lists/models/save-contact-role-info';
import { SaveContactLicenseInfo } from './contact-nav/contact-info-category-lists/models/save-contact-license-info';
import { SaveContactCompanyInfo } from './contact-nav/contact-info-category-lists/models/save-contact-company-info ';
import { AddNewContactCompany } from './contact-nav/contact-info-category-lists/models/add-new-contact-company';
import { SaveContactBasicInfo, SaveContactBasicTransportInfo } from './contact-nav/contact-info-category-lists/models/save-contact-basic-info';
import { SetContactSsnModel } from './models/setContactSsn.model';
import { UpdateSsnResponse } from './models/updateSsnResponse';
import { AddressListResponse, ArchiveCompanyContactResponse, ContactLicenseResponse, ContactListResponse, DivisionContactResponse, EmailListResponse, PhoneListResponse, WebsiteListResponse } from './models/responses';
import { ArchiveCompanyContactRequest, CheckContactDuplicateRequest, SetContactRoleStatusRequest, SetEmailTemplateToContactRequest, SetWebsiteRequest } from './models/requests';
import { DuplicateContactResponse } from './models/responses/duplicate-contact.response';
import { MissingContactAssociations } from './models/models';
import { Division } from '../../constants/division';

@Injectable()
export class ContactService {

  constructor(
    private httpClient: HttpClient,
  ) { }

  public addNewContact(model: AddNewContactCompany) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/AddContact`;
    return this.httpClient.post<any[]>(url, model);
  }

  public activateContact(contactId: number){
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Activate`;
    return this.httpClient.post<any[]>(url, contactId);
  }

  public archiveContact(contactId: number, deactivateChecklists: boolean = false) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Archive`;
    return this.httpClient.post<any[]>(url, { ContactId: contactId, DeactivateChecklists: deactivateChecklists });
  }

  public archiveCompanyContact(contactId: number, coreCompanyId: number, deactivateChecklist: boolean) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Archive/Company`;
    const request: ArchiveCompanyContactRequest = {
      ContactId: contactId,
      CoreCompanyId: coreCompanyId,
      DeactivateChecklist: deactivateChecklist
    };
    return this.httpClient.post<ArchiveCompanyContactResponse>(url, request);
  }

  public getCommTypeDropdown() {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/CommType/Dropdown`;
    return this.httpClient.get<any[]>(url);
  }

  public getCommTypes(commType: string) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/CommTypeList?commType=${commType}`;
    return this.httpClient.get<any[]>(url);
  }

  public getCompanyContacts(companyId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Company/Info?companyId=${companyId}`;
    return this.httpClient.get<any[]>(url);
  }

  // DEPRECATED - BP - 03/09/2026
  public getCompanyContactsByRole(companyId: number, roleId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Company/InfoByRole?companyId=${companyId}&roleId=${roleId}`;
    return this.httpClient.get<ContactListResponse[]>(url);
  }

  public getCompanyNonDriverContacts(companyId: number){
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Company/NonDriver?companyId=${companyId}`;
    return this.httpClient.get<ContactListResponse[]>(url);
  }

  public getCompanyDropdown(divisionId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Company/Dropdown?divisionId=${divisionId}`;
    return this.httpClient.get<any[]>(url);
  }

  public getContactByCompany(companyId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/GetCompanyContacts?companyId=${companyId}`;
    return this.httpClient.get<any[]>(url);
  }

  public getContactByDepartment(division: number, coreCompanyId?: number) {
    let url = `${environment.dotNetApiUrl}/${Area.core}/Contact/GetContacts?division=${division}`;

    if(coreCompanyId !== undefined && coreCompanyId !== null) {
      url += `&coreCompanyId=${coreCompanyId}`;
    }

    return this.httpClient.get<DivisionContactResponse[]>(url);
  }

  public getContactCommPreference(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/CommSource/GetContactPreferences?contactId=${contactId}`;
    return this.httpClient.get<any[]>(url);
  }

  public getContactDetails(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Details?contactId=${contactId}`;
    return this.httpClient.get<any>(url);
  }

  public getContactInfo(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact?contactId=${contactId}`;
    return this.httpClient.get<any[]>(url);
  }

  public getContactUser(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/GetUser?contactId=${contactId}`;
    return this.httpClient.get<any[]>(url);
  }

  public getContactsAddresses(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/AddressList?contactId=${contactId}`;
    return this.httpClient.get<any[]>(url);
  }

  public getContactsCompanies(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Company/List?contactId=${contactId}`;
    return this.httpClient.get<any[]>(url);
  }

  public getContactsEmails(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/EmailList?contactId=${contactId}`;
    return this.httpClient.get<any[]>(url);
  }

  public getContactsLicenses(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/LicenseList?contactId=${contactId}`;
    return this.httpClient.get<any[]>(url);
  }

  public getContactsPhones(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/PhoneList?contactId=${contactId}`;
    return this.httpClient.get<any[]>(url);
  }

  public getLicenseByDocumentId(documentId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/LicenseByDocument?documentId=${documentId}`;
    return this.httpClient.get<ContactLicenseResponse>(url);
  }

  public getContactsRoles(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/RoleList?contactId=${contactId}`;
    return this.httpClient.get<any[]>(url);
  }
  public getCoreCompanyDropdown() {
    const url = `${environment.dotNetApiUrl}/${Area.core}/CoreCompany/Dropdown`;
    return this.httpClient.get<any[]>(url);
  }

  public getCoreCompanyDropdownWithDivisions() {
    const url = `${environment.dotNetApiUrl}/${Area.core}/CoreCompany/DropdownWithDivisions`;
    return this.httpClient.get<any[]>(url);
  }

  public getCoreCompanyId(companyId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/Company/CoreCompanyId/${companyId}`;
    return this.httpClient.get<any[]>(url);
  }

  public getDivisionDropdown() {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Division/Dropdown`;
    return this.httpClient.get<any[]>(url);
  }

  public getDriverInfo(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/DriverInfo?contactId=${contactId}`;
    return this.httpClient.get<any[]>(url);
  }

  public getFullSsn(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.secure}/secureContactInfo/ssn?contactId=${contactId}`;
    return this.httpClient.get<string>(url);
  }

  public getLicenseTypeDropdown() {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/LicenseType/Dropdown`;
    return this.httpClient.get<any[]>(url);
  }

  public getLicenseTypes() {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/LicenseTypeList`;
    return this.httpClient.get<any[]>(url);
  }

  public getRoleTypeDropdown() {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/RoleType/Dropdown`;
    return this.httpClient.get<any[]>(url);
  }

  public getRoleTypes() {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/RoleTypeList`;
    return this.httpClient.get<any[]>(url);
  }

  public getSafetyContactDetails(contactId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/SafetyDetails?contactId=${contactId}`;
    return this.httpClient.get<any>(url);
  }

  public inactiveContactAddress(addressId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/InactiveAddress?id=${addressId}`;
    return this.httpClient.put<boolean>(url, []);
  }

  public inactiveContactEmail(emailId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/InactiveEmail?id=${emailId}`;
    return this.httpClient.put<boolean>(url, []);
  }

  public inactiveContactPhone(phoneId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/InactivePhone?id=${phoneId}`;
    return this.httpClient.put<boolean>(url, []);
  }

  public inactiveWebsites(websiteId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Website/Inactive?id=${websiteId}`;
    return this.httpClient.put<boolean>(url, []);
  }

  public removePhonePreference(contactId) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/CommSource/RemoveCommSource?contactId=${contactId}&commId=${1}`;
    return this.httpClient.patch<any[]>(url, {});
  }

  public saveContact(contact: SaveContactBasicInfo) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact`;
    return this.httpClient.post<any[]>(url, contact);
  }

  public saveContactAddress(contactAddress: SaveContactAddressInfo) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Address`;
    return this.httpClient.post<AddressListResponse>(url, contactAddress);
  }

  public saveContactCompany(contactRole: SaveContactCompanyInfo) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Company`;
    return this.httpClient.post<any[]>(url, contactRole);
  }

  public saveContactEmail(contactEmail: SaveContactEmailInfo) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Email`;
    return this.httpClient.post<EmailListResponse>(url, contactEmail);
  }

  public saveContactLicense(contactLicense: SaveContactLicenseInfo) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/License`;
    return this.httpClient.post<any[]>(url, contactLicense);
  }

  public deactivateContactLicense(license: ContactLicenseResponse) {
    const model: SaveContactLicenseInfo = new SaveContactLicenseInfo(
      license.id,
      license.contactId,
      license.licenseTypeId,
      license.licenseNumber,
      license.licenseEndorsements,
      license.licenseRestrictions,
      license.stateProvinceId,
      license.expirationDate,
      false
    );
    return this.saveContactLicense(model);
  }

  public deactivateOtherContactLicenses(contactLicenseId: number) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/License/${contactLicenseId}/DeactivateOthers`;
    return this.httpClient.post<number>(url, {});
  }

  public saveContactPhone(contactPhone: SaveContactPhoneInfo) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Phone`;
    return this.httpClient.post<PhoneListResponse>(url, contactPhone);
  }

  public saveContactPhoneAdmin(contactPhone: SaveContactPhoneInfo) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/PhoneAdmin`;
    return this.httpClient.post<PhoneListResponse>(url, contactPhone);
  }

  public saveContactRole(contactRole: SaveContactRoleInfo) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Role`;
    return this.httpClient.post<any[]>(url, contactRole);
  }

  public saveContactRoleStatus(contactRole: SetContactRoleStatusRequest) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/Role/Status/Update`;
    return this.httpClient.post<any[]>(url, contactRole);
  }

  public saveContactTransportDetail(contact: SaveContactBasicTransportInfo) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/TransportDetail`;
    return this.httpClient.post<any[]>(url, contact);
  }

  public setEmailQueue(emailInfo: SetEmailTemplateToContactRequest) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/SendEmail`;
    return this.httpClient.post<any[]>(url, emailInfo);
  }

  public setTransportBillingAddress(companyId: number, addressId: number) {
    const pushData = {
      companyId: companyId,
      addressId: addressId
    }
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/Company/UpdateBillingAddress`;
    return this.httpClient.post<AddressListResponse>(url, pushData);
  }

  setWebsiteCompany(pushData: SetWebsiteRequest) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/website`;
    return this.httpClient.post<WebsiteListResponse>(url, pushData);
  }

  public toPhoneString(phoneNumber: string) {
    if (phoneNumber && phoneNumber.length >= 10) {
      const areaCode = phoneNumber.substring(0, 3);
      const prefix = phoneNumber.substring(3, 6);
      const number = phoneNumber.substring(6);
      return `1 (${areaCode}) ${prefix}-${number}`
    }
    return "";
  }

  public updateContactNamePhoneEmail(any){
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/UpdateContactNamePhoneEmail`;
    return this.httpClient.post<any[]>(url, any);
  }

  /** Saves SSN.  Returns masked SSN */
  public updateSsn(model: SetContactSsnModel) {
    const url = `${environment.dotNetApiUrl}/${Area.secure}/secureContactInfo/ssn`;
    return this.httpClient.post<UpdateSsnResponse>(url, model);
  }

  // This endpoint is in ContactService (not ChecklistService) because it's used by both
  // Fleet Manager and Portal contact components. Placing it here avoids importing the large
  // ChecklistService into the Portal module just for this single method.
  public hasActiveChecklist(companyId: number, checklistTypeId: number, checklistKey: string) {
    const url = `${environment.dotNetApiUrl}/${Area.transportation}/checklists/HasActiveChecklist`;
    const params = { companyId: companyId.toString(), checklistTypeId: checklistTypeId.toString(), checklistKey: checklistKey };
    return this.httpClient.get<boolean>(url, { params });
  }

  public checkDuplicates(email: string, phoneNumber: string, driversLicenseNum: string) {
    const url = `${environment.dotNetApiUrl}/${Area.core}/Contact/CheckDuplicates`;
    const request: CheckContactDuplicateRequest = {};

    if (email) {
      request.Email = email;
    }

    if (phoneNumber) {
      request.PhoneNumber = phoneNumber;
    }

    if (driversLicenseNum) {
      request.DriversLicenseNum = driversLicenseNum;
    }

    return this.httpClient.post<DuplicateContactResponse[]>(url, request);
  }

  public getMissingContactAssociations(contactId: number, coreCompanyId: number, roleTypeId: number): Promise<MissingContactAssociations> {
    return Promise.all([
      this.getContactsCompanies(contactId).toPromise(),
      this.getContactsRoles(contactId).toPromise()
    ]).then(([companies, roles]) => {
      const hasCompany = companies && companies.some(c => c.companyId === coreCompanyId && c.isActive);
      const hasRole = roles && roles.some(r => r.contactRoleTypeId === roleTypeId && r.companyId === coreCompanyId && r.isActive);

      return { needsCompany: !hasCompany, needsRole: !hasRole };
    });
  }

  public createMissingContactAssociations(contactId: number, coreCompanyId: number, roleTypeId: number, needsCompany: boolean, needsRole: boolean, checkForChecklist: boolean = false): Promise<void> {
    const createCompany = needsCompany
      ? this.saveContactCompany(new SaveContactCompanyInfo(0, contactId, coreCompanyId, true, '')).toPromise()
      : Promise.resolve(null);

    return createCompany
      .then(() => {
        if (!needsRole) {
          return null;
        }

        const roleInfo = new SaveContactRoleInfo(0, contactId, roleTypeId, coreCompanyId, true, false, new Date(), null, Division.Transportation);
        roleInfo.checkForChecklist = checkForChecklist;

        return this.saveContactRole(roleInfo).toPromise();
      })
      .then(() => { });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/contacts/contact.service.ts